import { UserRoleEnum } from '@/types/auth.types';
import { SaleAreaItem } from '@/types/common.types';

export enum AccountStatusEnum {
  'during-an-invitation' = 'during-an-invitation',
  'registration-complete' = 'registration-complete',
  'invitation-expired' = 'invitation-expired',
}

export interface AccountsResponse {
  total_records: number;
  accounts: AccountResponseItem[];
}

export interface AccountResponseItem extends AccountRequest {
  id: number;
  status: AccountStatusEnum;
  created_at: string;
  sale_areas: SaleAreaItem[];
}

export interface AccountRequest {
  name: string;
  email: string;
  admin_type: UserRoleEnum;
  shop_name?: string;
}
